import apiClient from './apiClient';

export const adminAPI = {
  // User management
  users: {
    list: (params) => apiClient.get('/admin/users/', { params }),
    get: (id) => apiClient.get(`/admin/users/${id}/`),
    create: (data) => apiClient.post('/admin/users/', data),
    update: (id, data) => apiClient.put(`/admin/users/${id}/`, data),
    delete: (id) => apiClient.delete(`/admin/users/${id}/`),
    resetPassword: (id) => apiClient.post(`/admin/users/${id}/reset_password/`),
    setPassword: (id, data) => apiClient.post(`/admin/users/${id}/set_password/`, data),
    toggleActive: (id) => apiClient.post(`/admin/users/${id}/toggle_active/`),
    toggle2FA: (id, enabled) => apiClient.post(`/admin/users/${id}/toggle_2fa/`, { enabled }),
    unlock: (id) => apiClient.post(`/admin/users/${id}/unlock/`),
  },

  // Role management
  roles: {
    list: (params) => apiClient.get('/admin/roles/', { params }),
    get: (id) => apiClient.get(`/admin/roles/${id}/`),
    create: (data) => apiClient.post('/admin/roles/', data),
    update: (id, data) => apiClient.put(`/admin/roles/${id}/`, data),
    delete: (id) => apiClient.delete(`/admin/roles/${id}/`),
  },

  // System settings
  settings: {
    get: () => apiClient.get('/admin/settings/'),
    update: (data) => apiClient.put('/admin/settings/1/', data),
    testSmtp: (data) => apiClient.post('/admin/settings/test_smtp/', data),
  },

  // Audit log
  auditLog: {
    list: (params) => apiClient.get('/admin/audit-log/', { params }),
    get: (id) => apiClient.get(`/admin/audit-log/${id}/`),
    export: (params) => apiClient.get('/admin/audit-log/export/', {
      params,
      responseType: 'blob'
    }),
    stats: (params) => apiClient.get('/admin/audit-log/stats/', { params }),
  },
};
